import { v4 as uuidv4 } from 'uuid';
export const displayMessage = (content, type, userFunctions, severity) => {
    const id = uuidv4();
    userFunctions.setUserMessage({ id, content, label: content, type, severity: severity });
    setTimeout(() => userFunctions.dismissUserMessage({ id, content, label: content, type, severity: severity }), 3000);
};
